// One organization in the console (A19U2), owned by hand: read only; any platform role reads it (the layout lets in
// only staff).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../../components/ui/page-header'
import { ConsoleOrg } from '../../../features/platform/ConsoleOrgs'
import { consoleOrgQuery } from '../../../features/platform/queries'
import '../../../shared/shell/strings'
import { Part } from '../../../shared/shell/StatePart'

export const Route = createFileRoute('/platform/orgs/$orgId')({
  staticData: { screenId: 'ConsoleOrgDetailScreen', access: 'platform.org.read' },
  loader: ({ context: { queryClient }, params }) => queryClient.ensureQueryData(consoleOrgQuery(params.orgId)),
  component: ConsoleOrgDetailScreen,
})

function ConsoleOrgDetailScreen() {
  const { t } = useTranslation()
  const { orgId } = Route.useParams()
  return (
    // The section's name heads the page, outside the Part, so it stands while the organization loads (E22U6).
    <main data-testid={ids.consoleOrgDetail.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('shell.nav.orgs')} />
      <Part testId={ids.consoleOrgDetail.skeleton}>
        <ConsoleOrg orgId={orgId} />
      </Part>
    </main>
  )
}
